import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaCopy, FaCheck } from 'react-icons/fa';

const MoneyGiftPublic = ({ id }) => {
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/moneygifts/${id}`)
      .then(res => {
        setData(res.data);
      })
      .catch(err => {
        console.error('Error loading money gift:', err);
      });
  }, [id]);

  const handleCopy = () => {
    if (data?.account_number) {
      navigator.clipboard.writeText(data.account_number);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  if (!data) return null;

  return (
    <div className="bg-white shadow-md rounded-2xl max-w-md mx-auto mt-10 p-6 sm:p-8 text-gray-800">
      <h2 className="text-2xl font-bold mb-6 text-center text-gray-900">🎁 Money Gift</h2>

      <div className="space-y-4 text-base">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between">
          <span className="font-medium text-gray-600">Bank</span>
          <span className="text-right font-semibold">{data.bank_name}</span>
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center justify-between">
          <span className="font-medium text-gray-600">Account No.</span>
          <div className="flex items-center justify-end space-x-2">
            <span className="font-semibold">{data.account_number}</span>
            <button
              onClick={handleCopy}
              className="p-1 rounded-full bg-gray-100 hover:bg-gray-200 transition"
              title="Copy to clipboard"
            >
              {copied ? (
                <FaCheck className="text-green-600 w-4 h-4" />
              ) : (
                <FaCopy className="text-blue-600 w-4 h-4" />
              )}
            </button>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center justify-between">
          <span className="font-medium text-gray-600">Receiver</span>
          <span className="text-right font-semibold">{data.receiver_name}</span>
        </div>
      </div>
    </div>
  );
};

export default MoneyGiftPublic;
